import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/CourseLesson'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class CourseLessonStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "CourseLessonStore",
			variables: true,
		})
	}
}

export async function load_CourseLesson(params) {
	await initClient()

	const store = new CourseLessonStore()

	await store.fetch(params)

	return {
		CourseLesson: store,
	}
}
